import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import es from 'javascript-time-ago/locale/es';
import fr from 'javascript-time-ago/locale/fr';
import { setClassNames } from 'ddc-classnames-js';

export class ReviewDateComponent extends React.Component {
	render() {
		const { locale, reviewDate, fontSize } = this.props;
		const languages = { en, es, fr };
		TimeAgo.addLocale(languages[locale.split('_')[0]]);
		const timeAgo = new TimeAgo(locale.replace('_', '-'));

		return (
			<div className={setClassNames(['date', 'text-muted', fontSize])}>
				{timeAgo.format(new Date(reviewDate))}
			</div>
		);
	}
}

ReviewDateComponent.propTypes = {
	reviewDate: PropTypes.string.isRequired,
	locale: PropTypes.string.isRequired,
	fontSize: PropTypes.string
};

ReviewDateComponent.defaultProps = {
	fontSize: ''
};

const mapStateToProps = (state) => {
	return {
		locale: state.requestData.locale
	};
};

const mapDispatchToProps = (_dispatch) => ({});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ReviewDateComponent);
